import { useSession } from "../components/useSession/useSession";

import { config } from "../config";

type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

function useApiClient<T>(endpoint: string) {
  const { session } = useSession();

  return async (
    method: HttpMethod,
    route: string,
    requestBody?: any,
    params?: Record<string, string | number | undefined | null>
  ): Promise<T> => {
    if (!session) {
      throw new Error("User is not authenticated");
    }

    const authorization = `Bearer ${session.accessToken}`;
    const urlParams = params
      ? `?${new URLSearchParams(
          Object.entries(params)
            .filter(([, value]) => value !== undefined)
            .map(([key, value]) => [key, String(value)])
        ).toString()}`
      : "";

    const url = endpoint + route + urlParams;

    try {
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: authorization,
        },
        body: requestBody ? JSON.stringify(requestBody) : null,
      });

      if (!response.ok) {
        console.error(`Error ${method} ${url}: ${response.statusText}`);
        throw new Error(`HTTP Error: ${response.status}`);
      }

      return response.status === 204
        ? (null as unknown as T)
        : await response.json();
    } catch (error) {
      console.error(`Error ${method} ${url}: ${error}`);
      throw error;
    }
  };
}

export function useRbacApiClient<T>() {
  return useApiClient<T>(config.REACT_APP_RBAC_BACKEND_URL);
}

export function useDocApiClient<T>() {
  return useApiClient<T>(config.REACT_APP_DOC_BACKEND_URL);
}

export function useChatApiClient<T>() {
  return useApiClient<T>(config.REACT_APP_CHATBOT_BACKEND_URL);
}
